import React from "react";
import { ArrowUpRight, ArrowDownRight, Minus, Link2, PencilLine } from "lucide-react";
import { SectionLabel } from "@/components/app/primitives";

// Subtle tag showing how a metric is sourced. Manual now, Connected later
// (Xero / Stripe). Connected uses the single blue accent, manual stays muted.
export const SourceTag = ({ connected = false, label, testId }) => (
  <span
    data-testid={testId || "source-tag"}
    title={connected ? "Connected source" : "Entered manually"}
    className={`inline-flex items-center gap-1 rounded-sm border px-1.5 py-0.5 text-[10px] uppercase tracking-[0.1em] ${
      connected
        ? "border-[rgba(43,79,216,0.4)] bg-[rgba(43,79,216,0.1)] text-[#DCE6FF]"
        : "border-border bg-background/40 text-muted-foreground"
    }`}
  >
    {connected ? <Link2 className="h-3 w-3" strokeWidth={1.75} /> : <PencilLine className="h-3 w-3" strokeWidth={1.75} />}
    {label || (connected ? "Connected" : "Manual")}
  </span>
);

// Month-on-month delta. invert=true means a decrease is the good direction
// (used for churn and burn). Colour is restrained, never a large block.
export const Delta = ({ value, invert = false, format, suffix = "", testId }) => {
  if (value === null || value === undefined || isNaN(value)) return null;
  const positive = value > 0;
  const negative = value < 0;
  const good = invert ? negative : positive;
  const bad = invert ? positive : negative;
  const tone =
    value === 0
      ? "text-muted-foreground"
      : good
      ? "text-[rgba(34,197,94,0.92)]"
      : bad
      ? "text-[rgba(239,68,68,0.92)]"
      : "text-muted-foreground";
  const Icon = positive ? ArrowUpRight : negative ? ArrowDownRight : Minus;
  const shown = format ? format(Math.abs(value)) : Math.abs(value).toLocaleString();
  return (
    <span
      data-testid={testId || "delta"}
      className={`inline-flex items-center gap-0.5 font-mono tabular-nums text-[11px] ${tone}`}
    >
      <Icon className="h-3 w-3" strokeWidth={2} />
      {shown}{suffix}
    </span>
  );
};

export const MetricKpiCard = ({ label, value, sub, delta, connected = false, testId, valueTestId }) => (
  <div
    data-testid={testId || "venture-kpi"}
    className="rounded-md border border-border bg-card p-3 shadow-[inset_0_1px_0_rgba(255,255,255,0.06)]"
  >
    <div className="flex items-start justify-between gap-2">
      <SectionLabel>{label}</SectionLabel>
      <SourceTag connected={connected} testId={`${testId || "venture-kpi"}-source-tag`} />
    </div>
    <p
      data-testid={valueTestId || `${testId || "venture-kpi"}-value`}
      className="mt-2 font-mono tabular-nums text-[20px] leading-none text-foreground"
    >
      {value}
    </p>
    <div className="mt-2 flex items-center justify-between gap-2 min-h-[16px]">
      {sub ? <span className="font-mono tabular-nums text-[11px] text-muted-foreground">{sub}</span> : <span />}
      {delta}
    </div>
  </div>
);
